import React from 'react';

import ButtonWithPopover from '../ButtonWithPopover';
import {PawConstants} from '../../lookup/PawConstants';

import Button from 'react-bootstrap/Button';

import './PawStatus.css';

const ApprovePaw = (props) => {

  const acceptSwitch = () => {
    props.attemptStatusUpdate(props.wfId, PawConstants.status.Approved);
    document.body.click();
  }

  const reference = "acceptConfirmation";

  return (
    <ButtonWithPopover
      placement="top"
      customRef={reference + "bwp"}
      buttonVariant="success"
      buttonText="Approve"
      buttonIsBlock={true}
      buttonIsDisabled={props.disallowEditing}
      popoverTitle="Approve Switch"
      buttonId='switchdetails-btn-approve-popover'
    >
      <p className="confirmation-text">
        Do you want to <b>approve</b> this switch?
      </p>
      <div className="align-content-right">
        <Button id='switchdetails-btn-approve' className="left-spacer" variant="success" onClick={acceptSwitch}>
          Approve
        </Button>
      </div>
    </ButtonWithPopover>
  );
}

export default ApprovePaw;
